import { render, staticRenderFns } from "./tiscTabs.vue?vue&type=template&id=baed1290&"
import script from "./tiscTabs.vue?vue&type=script&lang=js&"
export * from "./tiscTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports